var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 165,
    viewBox: "0 0 107 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1563 83.1875V162.938C23.1563 164.313 24.0469 165 25.8281 165H66.7969C68.5781 165 69.4687 164.313 69.4687 162.938V81.8125H99.75C101.531 81.8125 102.422 81.125 102.422 79.75L105.094 55C105.094 53.625 104.203 52.9375 102.422 52.9375H69.4687V35.75C69.4687 31.625 73.9219 28.1875 80.1562 28.1875H103.313C105.984 28.1875 106.875 27.5 106.875 26.125V2.0625C106.875 0.687501 105.984 0 104.203 0H65.0156C41.8594 0 23.1563 13.0625 23.1563 29.5625V52.9375H2.67188C0.890627 52.9375 0 53.625 0 55V79.75C0 81.125 0.890627 81.8125 2.67188 81.8125H23.1563V83.1875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f6eb029584e0097e9f9c60a03530b544.svg";
export { ForwardRef as ReactComponent };